import React from 'react';
export function WhySection() {
  return <>
      <section className="border-b border-navy/10 bg-white px-3 py-4 sm:px-6" data-id="element-159" data-mp="h18whbyucjx2">
        <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="13vt4m45kcu1o">
          <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-161" data-mp="18ucqk4k5q5u1">
            Stop memorizing neurology without connecting the pieces
          </h2>
          <p className="mt-1.5 text-sm leading-snug sm:text-base" data-id="element-162" data-mp="1ik64vdbooz1z">
            Know the anatomy but struggle to connect it with the signs? Motor,
            sensory, cranial nerves, pathways and lesions — but how does
            everything fit together? Cortex, brainstem, spinal cord, peripheral
            nerve... where does the pattern point? NEUROLOGY VISUAL ATLAS™ gives
            you an organized visual study system to help you understand
            neurological structures, recognize patterns and connect findings
            with anatomy more systematically.
          </p>
          <p className="mt-1 text-center font-heading text-xs font-extrabold uppercase tracking-wide text-mid sm:text-sm" data-id="element-163" data-mp="27r2m0ug98gt">
            Visualize. Connect. Understand.
          </p>
        </div>
      </section>

      <section className="bg-mist px-3 py-4 sm:px-6" data-id="element-164" data-mp="28ptqmymynnq1">
        <div className="mx-auto max-w-2xl" data-id="element-165" data-mp="28qmxdzlx6d86">
          <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-166" data-mp="24o8j7st741n8">
            😩 Stop searching through different references for every neurology
            topic
          </h2>
          <p className="mt-1.5 text-sm leading-snug sm:text-base" data-id="element-167" data-mp="2wewj71j4v0zb">
            You're already studying neurology. The problem is wasting time
            jumping between textbooks, lectures, diagrams and disconnected
            information just to understand how everything connects. Open the
            system, choose the structure, pathway or clinical pattern and
            follow the organized visual references.
          </p>
          <p className="mt-1 text-center font-heading text-xs font-extrabold uppercase tracking-wide text-mid sm:text-sm" data-id="element-168" data-mp="1bxzvzmjsyr1s">
            Less searching. More structured studying.
          </p>
        </div>
      </section>
    </>;
}